/* Variant B PDP v2 · buy-box glue (badge row, gallery badges, CTA price), sticky add-to-cart, spec rows, FAQ, founder video */
(function () {
  'use strict';
  if (window.__tbpReady) return;
  window.__tbpReady = true;

  var DESKTOP = '(min-width: 990px)';
  var PHONE = '(max-width: 749px)';
  function isDesktop() { return window.matchMedia(DESKTOP).matches; }

  /* ---------- buy box: move the verified pill next to the Judge.me badge, badges over the gallery, price on the CTA ---------- */
  /* "4,8" next to the Judge.me stars (the badge itself only prints the count) */
  function addRatingNumber(badge) {
    if (badge.querySelector('.tbp-rating-num')) return;
    var avg = parseFloat(badge.getAttribute('data-average-rating'));
    if (!avg) return;
    var num = document.createElement('span');
    num.className = 'tbp-rating-num';
    num.textContent = avg.toFixed(1).replace('.', ',');
    var stars = badge.querySelector('.jdgm-prev-badge__stars');
    if (stars && stars.nextSibling) badge.insertBefore(num, stars.nextSibling); else badge.appendChild(num);
  }

  function initBuybox() {
    var pill = document.querySelector('[data-tbp-verified]');
    if (pill && !pill.dataset.tbpMoved) {
      var ownBlock = pill.closest('.product__block');           /* the pill's own custom_liquid block: hide it once the pill has moved */
      var movePill = function (badge) {
        addRatingNumber(badge);
        badge.appendChild(pill);
        pill.dataset.tbpMoved = '1';
        if (ownBlock && !ownBlock.contains(badge)) ownBlock.style.display = 'none';
      };
      var badge = document.querySelector('product-info .jdgm-prev-badge');
      if (badge) {
        movePill(badge);
      } else {
        /* Judge.me renders late: retry a few times */
        var tries = 0;
        var timer = setInterval(function () {
          var b = document.querySelector('product-info .jdgm-prev-badge');
          if (b || ++tries > 20) { clearInterval(timer); if (b) movePill(b); }
        }, 250);
      }
    }
    var badges = document.querySelector('[data-tbp-gallery-badges]');
    if (badges && !badges.dataset.tbpMoved) {
      var viewer = document.querySelector('product-info .product__media-gallery-viewer-wrap') || document.querySelector('product-info .product__media-gallery');
      if (viewer) { viewer.appendChild(badges); badges.hidden = false; badges.dataset.tbpMoved = '1'; }
    }
    var delivery = document.querySelector('[data-tbp-delivery]');
    var btn = document.querySelector('product-info .product-form__submit');
    if (delivery && btn && !btn.querySelector('.tbp-cta-price') && !btn.disabled) {
      var price = document.createElement('span');
      price.className = 'tbp-cta-price';
      price.textContent = delivery.getAttribute('data-price') || '';
      var label = btn.querySelector('span:not([class*="loading"]):not(.icon)') || btn;
      label.appendChild(price);
    }
  }

  /* ---------- sticky add-to-cart (phones): show once the buy button leaves the viewport ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-tbp-sticky]');
    if (!bar || bar.dataset.tbpDone) return;
    bar.dataset.tbpDone = '1';
    var addBtn = bar.querySelector('[data-tbp-sticky-add]');
    function anyDrawerOpen() { return !!document.querySelector('.drawer[open], cart-drawer[open], menu-drawer[open]'); }

    function buyButton() { return document.querySelector('product-info .product-form__submit, product-info form[action*="/cart/add"] button[type="submit"]'); }
    function footerEl() { return document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer'); }

    var ticking = false;
    function update() {
      ticking = false;
      var btn = buyButton();
      var footer = footerEl();
      var rect = btn ? btn.getBoundingClientRect() : null;
      /* theme B: also while the button is still below the first screen (median phone viewport on Tomi is ~650 px, PostHog 8.10) */
      var isB = document.body.classList.contains('tb-b');
      /* phones: the bar is a solid strip, so it stays until the whole button has cleared it; wider screens: a floating pill, only while the button is fully off screen */
      var below = rect ? (window.matchMedia(PHONE).matches ? rect.bottom > window.innerHeight - (bar.offsetHeight || 0) : rect.top > window.innerHeight) : false;
      var btnGone = rect ? (rect.bottom < 0 || (isB && below)) : false;
      var footerVisible = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      var fin = document.querySelector('.tbb-final__btn');
      var finRect = fin ? fin.getBoundingClientRect() : null;
      var finVisible = finRect ? (finRect.top < window.innerHeight - 72 && finRect.bottom > 0) : false;   /* theme B final buy block */
      var show = btnGone && !footerVisible && !finVisible && !anyDrawerOpen() && (window.matchMedia(PHONE).matches || document.body.classList.contains('tb-b'));
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('tbp-sticky-on', show);   /* lets CSS lift third-party floaters (Klaviyo teaser) above the bar */
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (addBtn) addBtn.tabIndex = show ? 0 : -1;
    }
    function schedule() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    /* any open drawer (cart, menu, search): found fresh each time, because the cart drawer element is replaced on re-render */
    if ('MutationObserver' in window) {
      new MutationObserver(schedule).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
    }
    schedule();

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var btn = buyButton();
        var form = btn && btn.closest('form');
        if (btn && !btn.disabled) {
          btn.click();             /* goes through the theme's product-form (AJAX add + cart drawer) */
        } else if (form && form.requestSubmit) {
          form.requestSubmit();
        } else if (form) {
          form.submit();
        }
      });
    }
    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      var price = bar.querySelector('.tbp-sticky__price');
      if (price && window.FoxTheme && FoxTheme.formatMoney) price.textContent = FoxTheme.formatMoney(v.price, window.FoxTheme.settings && FoxTheme.settings.money_format);
    });
  }

  /* ---------- specs: "Label: value" list items → two-column rows ---------- */
  function initSpecs() {
    document.querySelectorAll('[data-tbp-spec-rows]').forEach(function (box) {
      if (box.dataset.tbpDone) return;
      box.dataset.tbpDone = '1';
      var items = box.querySelectorAll('h2, h3, h4, li');
      if (!box.querySelector('li')) return;
      var table = document.createElement('dl');
      table.className = 'tbp-specs__rows';
      items.forEach(function (li) {
        if (li.tagName !== 'LI') {
          var head = document.createElement('dt');
          head.className = 'tbp-specs__group';
          head.textContent = li.textContent.trim();
          if (head.textContent) table.appendChild(head);
          return;
        }
        var strong = li.querySelector('strong, b');
        var label, value;
        if (strong) {
          label = strong.textContent.replace(/:\s*$/, '').trim();
          strong.remove();
          value = li.textContent.replace(/^\s*:?\s*/, '').trim();
        } else {
          var parts = li.textContent.split(':');
          label = (parts.shift() || '').trim();
          value = parts.join(':').trim();
        }
        if (!value) { value = label; label = ''; }
        var dt = document.createElement('dt'); dt.textContent = label;
        var dd = document.createElement('dd'); dd.textContent = value;
        if (!label) { dd.className = 'is-wide'; table.appendChild(dd); return; }
        table.appendChild(dt); table.appendChild(dd);
      });
      box.replaceChildren(table);
    });
  }

  /* ---------- FAQ: optionally all open on desktop ---------- */
  function initFaq() {
    document.querySelectorAll('[data-tbp-faq]').forEach(function (sec) {
      if (sec.getAttribute('data-open-desktop') !== 'true') return;
      var items = sec.querySelectorAll('details');
      var mobileState = null;
      var sync = function () {
        if (isDesktop()) {
          if (!mobileState) mobileState = [].map.call(items, function (d) { return d.open; });
          items.forEach(function (d) { d.open = true; });
        } else if (mobileState) {
          items.forEach(function (d, i) { d.open = mobileState[i]; });
          mobileState = null;
        }
      };
      sync(); window.matchMedia(DESKTOP).addEventListener('change', sync);
    });
  }

  /* ---------- founder video: card → inline player ---------- */
  function initFounder() {
    document.querySelectorAll('[data-tbp-video-open]').forEach(function (btn) {
      if (btn.dataset.tbpDone) return;
      btn.dataset.tbpDone = '1';
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.tbp-founder__video');
        var player = wrap && wrap.querySelector('[data-tbp-player]');
        var video = player && player.querySelector('video');
        if (!player) return;
        player.hidden = false;
        wrap.classList.add('is-playing');
        if (video) { video.muted = false; var p = video.play(); if (p && p.catch) p.catch(function () {}); }
      });
    });
  }

  /* ---------- delivery: countdown to the cutoff + expected date (Sobczyk shipping-box math) ---------- */
  function initDelivery() {
    var box = document.querySelector('[data-tbp-delivery]');
    if (!box || box.dataset.tbpDone) return;
    box.dataset.tbpDone = '1';
    var cutoffHour = parseInt(box.getAttribute('data-cutoff-hour') || '12', 10);
    var cutoffMinute = parseInt(box.getAttribute('data-cutoff-minute') || '0', 10);
    var names = (box.getAttribute('data-weekdays') || 'ma,ti,ke,to,pe,la,su').split(',');
    var timerEl = box.querySelector('[data-tbp-countdown]');
    var etaEl = box.querySelector('[data-tbp-eta]');
    if (!timerEl && !etaEl) return;
    /* Helsinki wall-clock time as a local Date, so the cutoff is the warehouse's, not the visitor's. */
    var fmtParts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Helsinki', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    function helsinkiNow() { var o = {}; fmtParts.formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; }); return new Date(+o.year, +o.month - 1, +o.day, +o.hour, +o.minute, +o.second); }
    function isWeekday(d) { var w = d.getDay(); return w !== 0 && w !== 6; }
    function cutoffOn(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate(), cutoffHour, cutoffMinute, 0, 0); }
    function addBusinessDays(date, days) { var d = new Date(date.getTime()); while (days > 0) { d.setDate(d.getDate() + 1); if (isWeekday(d)) days--; } return d; }
    function shipsToday(now) { return isWeekday(now) && now < cutoffOn(now); }
    /* next weekday cutoff: today if still before it, else the next business day (weekends count down to Monday) */
    function nextCutoff(now) { if (shipsToday(now)) return cutoffOn(now); return cutoffOn(addBusinessDays(now, 1)); }
    /* same rule as the shipping box: shipped today → +1 business day, otherwise +2 */
    function expectedDelivery(now) { return addBusinessDays(now, shipsToday(now) ? 1 : 2); }
    function fmt(d) { var w = (d.getDay() + 6) % 7; return names[w] + ' ' + d.getDate() + '.' + (d.getMonth() + 1) + '.'; }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = helsinkiNow();
      if (timerEl) { var diff = Math.max(0, nextCutoff(now) - now); timerEl.textContent = pad(Math.floor(diff / 3600000)) + ':' + pad(Math.floor((diff % 3600000) / 60000)) + ':' + pad(Math.floor((diff % 60000) / 1000)); }
      if (etaEl) etaEl.textContent = fmt(expectedDelivery(now));
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- reviews header: Judge.me's minimal header prints "4.8 / 31 arvostelut" without stars → add an average star row ---------- */
  function initReviewsHeader() {
    var tries = 0;
    var timer = setInterval(function () {
      var box = document.querySelector('.tbp-reviews .jm-average-rating-display .jm-cluster');
      if (!box && ++tries < 40) return;
      clearInterval(timer);
      if (!box || box.querySelector('.tbp-avg-stars')) return;
      var ps = box.querySelectorAll('p');
      if (ps.length < 1) return;
      var avg = parseFloat((ps[0].textContent || '').replace(',', '.'));
      if (!avg) return;
      ps[0].classList.add('tbp-avg-num');
      ps[0].textContent = avg.toFixed(1).replace('.', ',');
      if (ps[1]) ps[1].classList.add('tbp-avg-count');
      var star = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l3 6.6 7 .8-5.2 4.8 1.4 7L12 17.8 5.8 21.2l1.4-7L2 9.4l7-.8z"/></svg>';
      var row = document.createElement('span');
      row.className = 'tbp-avg-stars';
      row.setAttribute('aria-label', avg.toFixed(1).replace('.', ',') + ' / 5');
      row.innerHTML = '<span class="tbp-avg-stars__bg">' + star + star + star + star + star + '</span><span class="tbp-avg-stars__fg" style="width:' + Math.round(avg / 5 * 1000) / 10 + '%">' + star + star + star + star + star + '</span>';
      ps[0].insertAdjacentElement('afterend', row);
    }, 250);
  }

  function boot() { initReviewsHeader(); initDelivery(); initBuybox(); initSticky(); initSpecs(); initFaq(); initFounder(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () { initDelivery(); initBuybox(); initSpecs(); initFaq(); initFounder(); });
})();
